import { NavBar } from '../../../../themes/components/Navbar';
import { Sidebar } from '../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { BuscaPedidos } from '../../components/BuscaPedidos';
import { TabelaListaPrePedidos } from '../../components/TabelaListaPrePedidos';

export const ConsultarPrePedidos = () => {
    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div className="main-content-novo-pedido">
                    <NavBar />
                    <span className="novo-pedido-title-form">Lista de Pré-Pedidos</span>
                    <TabelaListaPrePedidos />
                </div>
            </div>
            <Toaster />
        </div>
    )
}